import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "country-mx", class: _vm.$x.nsAddressForm },
    [
      _c(
        "div",
        { class: _vm.$x.dualColumn },
        [
          _c(
            "div",
            { staticClass: "flex-column", class: _vm.$x.col },
            [
              _c(VTextField, {
                class: _vm.$x.postCodeMessage,
                attrs: {
                  label: _vm.t.postalCodeLabel,
                  name: "postalCode",
                  maxlength: "5",
                  required: "",
                  "validate-on-blur": "",
                  rules: _vm.postalCodeRules,
                  "hide-details": false,
                  "error-messages": _vm.postCodeErrors,
                },
                on: { blur: _vm.onBlur, input: _vm.postCodeChanged },
                model: {
                  value: _vm.address.postalCode,
                  callback: function ($$v) {
                    _vm.$set(_vm.address, "postalCode", $$v)
                  },
                  expression: "address.postalCode",
                },
              }),
              _vm._v(" "),
              _c("span", {
                class: _vm.$x.postalCodeHint,
                domProps: {
                  innerHTML: _vm._s(
                    _vm.sanitizeHTMLCode(_vm.t.postCodeDescription)
                  ),
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(VTextField, {
            ref: "addressRegion",
            staticClass: "flex-column",
            class: _vm.$x.col,
            attrs: {
              name: "region",
              maxlength: "4",
              required: "",
              "validate-on-blur": "",
              label: _vm.t.regionLabel,
              rules: _vm.cityRules,
              readonly: _vm.postCodeLookedUp,
            },
            on: { input: _vm.addressUpdated },
            model: {
              value: _vm.address.region,
              callback: function ($$v) {
                _vm.$set(_vm.address, "region", $$v)
              },
              expression: "address.region",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(VTextField, {
        ref: "addressCity",
        staticClass: "flex-column",
        attrs: {
          name: "city",
          maxlength: "30",
          required: "",
          "validate-on-blur": "",
          label: _vm.t.cityLabel,
          rules: _vm.cityRules,
          readonly: _vm.postCodeLookedUp,
        },
        on: { blur: _vm.onBlur, input: _vm.addressUpdated },
        model: {
          value: _vm.address.city,
          callback: function ($$v) {
            _vm.$set(_vm.address, "city", $$v)
          },
          expression: "address.city",
        },
      }),
      _vm._v(" "),
      _c("NsSelect", {
        staticClass: "flex-column",
        attrs: {
          items: _vm.districts,
          name: "district",
          label: _vm.t.districtLabel,
          rules: _vm.requiredRule,
        },
        on: { blur: _vm.onBlur, input: _vm.addressUpdated },
        model: {
          value: _vm.address.district,
          callback: function ($$v) {
            _vm.$set(_vm.address, "district", $$v)
          },
          expression: "address.district",
        },
      }),
      _vm._v(" "),
      _c(VTextField, {
        staticClass: "flex-column",
        attrs: {
          name: "address1",
          maxlength: "50",
          required: "",
          "validate-on-blur": "",
          label: _vm.t.address1Label,
          rules: _vm.address1Rules,
        },
        on: { blur: _vm.onBlur, input: _vm.addressUpdated },
        model: {
          value: _vm.address.address1,
          callback: function ($$v) {
            _vm.$set(_vm.address, "address1", $$v)
          },
          expression: "address.address1",
        },
      }),
      _vm._v(" "),
      _c(VTextField, {
        staticClass: "flex-column",
        attrs: {
          name: "address2",
          maxlength: "50",
          "validate-on-blur": "",
          "aria-label": _vm.t.address2Label,
          rules: _vm.address2Rules,
        },
        on: { blur: _vm.onBlur, input: _vm.addressUpdated },
        scopedSlots: _vm._u([
          {
            key: "label",
            fn: function () {
              return [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.t.address2Label) +
                    "\n            "
                ),
                _c("span", { class: _vm.$x.optional }, [
                  _vm._v(" " + _vm._s(_vm.t.optional) + " "),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.address.address2,
          callback: function ($$v) {
            _vm.$set(_vm.address, "address2", $$v)
          },
          expression: "address.address2",
        },
      }),
      _vm._v(" "),
      _vm.includeEmail
        ? _c(VTextField, {
            staticClass: "flex-column",
            attrs: {
              name: "email",
              maxlength: "50",
              required: "",
              "validate-on-blur": "",
              label: _vm.t.emailLabel,
              rules: _vm.emailRules,
            },
            on: { input: _vm.addressUpdated, blur: _vm.onBlur },
            model: {
              value: _vm.address.email,
              callback: function ($$v) {
                _vm.$set(_vm.address, "email", $$v)
              },
              expression: "address.email",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "NsModal",
        {
          attrs: {
            attach: "",
            "context-class": "addressModal",
            title: _vm.t.addressSelect,
          },
          model: {
            value: _vm.modalOpen,
            callback: function ($$v) {
              _vm.modalOpen = $$v
            },
            expression: "modalOpen",
          },
        },
        [
          _c(VLayout, { staticClass: "mb-4" }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm.t.addressVerificationContext) +
                "\n        "
            ),
          ]),
          _vm._v(" "),
          _c(VDivider),
          _vm._v(" "),
          _c(
            VForm,
            { ref: "addressSelectForm", staticClass: "font-weight-regular" },
            [
              _c(
                VRadioGroup,
                { staticClass: "pt-4 pl-4" },
                [
                  _c(VLayout, { staticClass: "mb-3 font-weight-bold" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.t.original) +
                        "\n                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    VRadio,
                    {
                      key: _vm.address.address1,
                      attrs: {
                        "v-model": _vm.selectedAddress,
                        value: _vm.address,
                        color: "#7123d9",
                      },
                      on: { change: _vm.addressSelected },
                    },
                    [
                      _c(
                        "template",
                        { slot: "label" },
                        [
                          _c(
                            VLayout,
                            { staticClass: "font-weight-regular" },
                            [
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.sanitizeHTMLCode(
                                      _vm.formatAddress(_vm.address)
                                    )
                                  ),
                                },
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(VLayout, { staticClass: "mt-3 font-weight-bold" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.t.suggested) +
                        "\n                "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.suggestedAddressesValue &&
                  _vm.suggestedAddressesValue.length == 0
                    ? _c(VLayout, { staticClass: "mt-3" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.t.noSuggestionsFound) +
                            "\n                "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.suggestedAddressesValue &&
                  _vm.suggestedAddressesValue.length > 0
                    ? _vm._l(_vm.suggestedAddressesValue, function (item) {
                        return _c(
                          VRadio,
                          {
                            key: item.address1,
                            staticClass: "mt-3",
                            attrs: {
                              "v-model": _vm.selectedAddress,
                              value: item,
                              color: "#7123d9",
                            },
                            on: { change: _vm.addressSelected },
                          },
                          [
                            _c(
                              "template",
                              { slot: "label" },
                              [
                                _c(
                                  VLayout,
                                  { staticClass: "font-weight-regular" },
                                  [
                                    _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.sanitizeHTMLCode(
                                            _vm.formatAddress(item, true)
                                          )
                                        ),
                                      },
                                    }),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          2
                        )
                      })
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          ),
          _vm._v(" "),
          [
            _c(
              VLayout,
              { attrs: { "align-center": "", "justify-center": "" } },
              [
                _c(VLayout, { attrs: { sm: "3", xs: "12" } }, [
                  _c(
                    "button",
                    {
                      staticClass: "primary-hit fluid",
                      staticStyle: { margin: "5px" },
                      attrs: {
                        flat: "",
                        outline: "",
                        block: "",
                        disabled:
                          Object.entries(_vm.selectedAddress).length === 0,
                      },
                      on: {
                        click: function () {
                          _vm.addressConfirmed(_vm.selectedAddress)
                          _vm.selectedAddress = {}
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.t.confirmAddress) +
                          "\n                    "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "secondary-hit fluid",
                      staticStyle: { margin: "5px" },
                      attrs: { flat: "", outline: "", block: "" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          $event.stopPropagation()
                          return function () {
                            _vm.addressClose()
                            _vm.selectedAddress = {}
                          }.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.t.cancel) +
                          "\n                    "
                      ),
                    ]
                  ),
                ]),
              ],
              1
            ),
          ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }